import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppWarn } from './appWarn.model';
import { WarnService } from './warn.service';

@Component({
  selector: 'app-warn',
  templateUrl: './warn.component.html',
  styleUrls: ['./warn.component.scss']
})
export class WarnComponent implements OnInit {

  @ViewChild('warnDiv') warnDiv: ElementRef;

  warn: AppWarn;

  // objeto de la modal
  modalReference: any;

  constructor(
    private warnService: WarnService,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.warnService.getSubject().subscribe(warn => {
        this.showWarn(warn);
    });
  }

  showWarn(warn: AppWarn): void {
    this.warn = warn;
    this.modalReference = this.modalService.open(
      this.warnDiv,
      {
        centered: true,
        backdrop: 'static',
        keyboard: true
      }
    );
  }

  hidenWarn(): void {
    this.modalReference.close();
  }

}
